import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const DBMSModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Module-1', path: '/dbms-m1-s1' }
    ],
    'Module 2': [
      { name: 'Keys', path: '/dbms-m2-s1' },
      { name: 'ER diagram', path: '/dbms-m2-s2' },
      { name: 'ER to table', path: '/dbms-m2-s3' },
      { name: 'Extended ER diagrams (Generalization, Specialization, Aggregations)', path: '/dbms-m2-s4' }
    ],
    'Module 3': [
      { name: 'Armstrong AXIOM, Finding Closures, Candidate Keys, Minimal Cover, Equivalence, Dependency Preservation', path: '/dbms-m3-s1' },
      { name: 'Normalization', path: '/dbms-m3-s2' },
      { name: 'Multi-valued dependency and Fourth Normal form - Join dependency and Fifth Normal form', path: '/dbms-m3-s3' }
    ],
    'Module 4': [
      { name: 'File Organization - Indexing: Single level indexing, multi-level indexing, dynamic multilevel Indexing - B+ Tree Indexing', path: '/dbms-m4-s1' },
      { name: 'Hashing Techniques: Static and Dynamic Hashing', path: '/dbms-m4-s2' },
      { name: 'Relational Algebra - Translating SQL Queries into Relational Algebra – Query Processing', path: '/dbms-m4-s3' },
      { name: 'Query Optimization', path: '/dbms-m4-s4' },
      { name: 'Tuple Relational calculus', path: '/dbms-m4-s5' }
    ],
    'Module 5': [
      { name: 'Introduction to Transaction Processing – Transaction concepts: ACID Properties of Transactions', path: '/dbms-m5-s1' },
      { name: 'Transaction States - Serial and Serializable Schedules', path: '/dbms-m5-s2' },
      { name: 'Schedules based on recoverability – Schedules based on Serializability - Conflict Serializability', path: '/dbms-m5-s3' },
      { name: 'Recovery Concepts: Log Based Recovery Protocols, Recovery based on deferred update, Recovery techniques based on immediate update – Shadow Paging Algorithm', path: '/dbms-m5-s4' }
    ],
    'Module 6': [
      { name: 'Concurrent Transactions – Lost Update Problem', path: '/dbms-m6-s1' },
      { name: 'Concurrency Control Techniques: Time Stamp Based Protocols, Thomas Write Rule, Lock Based Protocols, Lock Compatibility Matrix', path: '/dbms-m6-s2' },
      { name: 'Two-Phase Locking Protocol', path: '/dbms-m6-s3' },
      { name: 'Graph Based Protocols for Concurrency Control - Tree Protocol for Concurrency Control', path: '/dbms-m6-s4' },
      { name: 'Deadlocks Based on Locks in Transactions – Deadlock Handling Techniques – Transaction Deadlock Detection Techniques – Transaction Deadlock Prevention Techniques – Multi-Granularity Locking for avoiding Transaction Deadlocks', path: '/dbms-m6-s5' }
    ],
    'Module 7': [
      { name: 'Introduction, Need of NoSQL, CAP Theorem, different NoSQL data bases: Key-value data stores, Columnar families, Document databases, Graph databases', path: '/dbms-m7-s1' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Database Systems</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-DBMSModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DBMSModules;
